import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../State';
import { QualificationActions } from '../../../State/actions/mdqx/doctor/qualification.actions';
import { getQualificationFetched } from '../../../State/selectors/mdqx/doctor/qualification.selector';
import { BaseEntityResolver } from '../../resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class QualificationResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getQualificationFetched, QualificationActions.loadRequest({ Payload: {} }), store);
    }
}
